import { environment } from './../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Page } from 'src/app/@shared/models';

@Injectable({ providedIn: 'root' })
export abstract class BaseCrudService {

  private readonly APIUrl = this.getBaseAPIPath();

  constructor(protected readonly httpClient: HttpClient) {
  }

  abstract getBaseAPIPath(): string;

  getFullAPIUrl(endpoint?: string): string {
    let apiUrl= `${this.APIUrl}`;

    if (endpoint) {
      // apiUrl = environment.apiEndPoint + apiUrl +`/${endpoint}`;
      apiUrl += `/${endpoint}`;
    }
    return apiUrl;
  }

  toServerModel(entity: any): any {
    return entity;
  }

  fromServerModel(json: any): any {
    return json;
  }

  getList<ReturnType>(endpoint?: string): Observable<ReturnType[]> {
    return this.httpClient.get<ReturnType[]>(`${this.getFullAPIUrl(endpoint)}`)
      .pipe(map((list) => list.map((item) => this.fromServerModel(item))));
  }

  getListWithPagination<ReturnType>(page: number, size: number, endpoint?: string): Observable<Page<ReturnType>> {
    const params = new HttpParams()
      .set('page', (page - 1).toString())
      .set('size', size.toString());
    return this.httpClient.get<Page<ReturnType>>(`${this.getFullAPIUrl(endpoint)}${params.toString()}`,)
      .pipe(map((item) => {
        return {
          ...item,
          content: item.content.map(i => this.fromServerModel(i))
        }
      }));
  }

  getListWithFiltersWithPagination<FilterParam, ReturnType>(filter: FilterParam, page: number, size: number, endpoint?: string): Observable<Page<ReturnType>> {
    const params = new HttpParams()
      .set('page', (page - 1).toString())
      .set('size', size.toString());
    return this.httpClient.post<Page<ReturnType>>(`${this.getFullAPIUrl(endpoint)}?${params.toString()}`, filter)
      .pipe(map((item) => {
        return {
          ...item,
          content: item.content.map(i => this.fromServerModel(i))
        }
      }));
  }

  get<ReturnType>(id?: string | number | null, endpoint?: string): Observable<ReturnType> {
    let ep = this.getFullAPIUrl(endpoint);
    if (id) {
      ep += `/${id}`;
    }
    return this.httpClient.get<ReturnType>(ep).pipe(map((json) => this.fromServerModel(json)));
  }

  add<ReturnType, RequestBodyType>(resource: RequestBodyType, endpoint?: string): Observable<ReturnType> {
    return this.httpClient.post<ReturnType>(`${this.getFullAPIUrl(endpoint)}`, this.toServerModel(resource));
  }

  delete(id: string | number, endpoint?: string): Observable<any> {
    return this.httpClient.delete(`${this.getFullAPIUrl(endpoint)}/${id}`);
  }

  update<ReturnType, RequestBodyType>(resource: RequestBodyType, endpoint?: string): Observable<ReturnType> {
    return this.httpClient.put<ReturnType>(`${this.getFullAPIUrl(endpoint)}`, this.toServerModel(resource));
  }

  patch<ReturnType>(resource: ReturnType, endpoint?: string) {
    return this.httpClient.patch(`${this.getFullAPIUrl(endpoint)}`, this.toServerModel(resource));
  }
}
